import React, { FunctionComponent, memo } from 'react'

import Tab from '../../../../../shared/components/Tab'
import { Container } from './styles'
import { ITypeOptionsProps } from './TabOptionsComponent.types'

const TabOptions: FunctionComponent<ITypeOptionsProps> = memo(
  ({ setActiveMenu, activeMenu, disabled }) => {
    return (
      <Container>
        <Tab>
          <Tab.Item
            onClick={() => {
              setActiveMenu('extrato')
            }}
            active={activeMenu === 'extrato'}
            disabled={true}
          >
            <span>Extrato</span>
          </Tab.Item>
          <Tab.Item
            onClick={() => {
              setActiveMenu('transferir')
            }}
            active={activeMenu === 'transferir'}
            disabled={true}
          >
            <span>Transferir</span>
          </Tab.Item>
          <Tab.Item
            onClick={() => {
              setActiveMenu('ptransf')
            }}
            active={activeMenu === 'ptransf'}
            disabled={disabled}
          >
            <span>% de transferência</span>
          </Tab.Item>
          <Tab.Item
            onClick={() => {
              setActiveMenu('trazerDinheiro')
            }}
            active={activeMenu === 'trazerDinheiro'}
            disabled={true}
          >
            <span>Trazer dinheiro</span>
          </Tab.Item>
        </Tab>
      </Container>
    )
  },
)
TabOptions.displayName = 'TabOptions'
export default TabOptions
